"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./StudentLoanPaydown.css");

var _react = _interopRequireDefault(require("react"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _MarketingHero = _interopRequireDefault(require("../components/MarketingHero"));

var _MarketingProductNavbar = _interopRequireDefault(require("../components/MarketingProductNavbar"));

var _MarketingImpactCalculatorWrapper = _interopRequireDefault(require("../components/employee/MarketingImpactCalculatorWrapper"));

var _CustomizeBenefits = _interopRequireDefault(require("../components/CustomizeBenefits"));

var _LogoGarden = _interopRequireDefault(require("../components/LogoGarden"));

var _ImpactCalculatorStore = _interopRequireDefault(require("../../shared/models/calculator/impact/ImpactCalculatorStore"));

var _SessionStore = _interopRequireDefault(require("../../shared/models/session/SessionStore"));

var _OnboardingCard = _interopRequireDefault(require("../components/products/OnboardingCard"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _MarketingCarousel = require("../components/MarketingCarousel");

var _QuoteSelector = _interopRequireWildcard(require("../components/QuoteSelector"));

var _mobxReact = require("mobx-react");

var _Percentage = _interopRequireDefault(require("../components/Percentage"));

var _formatters = _interopRequireDefault(require("../../util/formatters"));

var _floor = _interopRequireDefault(require("lodash/floor"));

var _numeral = _interopRequireDefault(require("numeral"));

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LEGAL_TEXT_KEYS = ["legalText1", "legalText2"];

var StudentLoanPaydown = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(StudentLoanPaydown, _React$Component);

  var _super = _createSuper(StudentLoanPaydown);

  function StudentLoanPaydown() {
    _classCallCheck(this, StudentLoanPaydown);

    return _super.apply(this, arguments);
  }

  _createClass(StudentLoanPaydown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          extraPayment = _this$props.extraPayment,
          _this$props$stats = _this$props.stats,
          extraPaymentTerm = _this$props$stats.extraPaymentTerm,
          defaultMonthlyPrincipal = _this$props$stats.defaultMonthlyPrincipal,
          principalSavings = _this$props$stats.principalSavings;
      var yearsAndMonthsRemaining = defaultMonthlyPrincipal.length - extraPaymentTerm;
      var years = (0, _floor.default)(yearsAndMonthsRemaining / 12);
      var months = (0, _floor.default)(yearsAndMonthsRemaining % 12);
      var formatedYearString = years > 0 ? "".concat(years, " year").concat(years > 1 ? "s" : "") : "";
      var formatedMonthString = months > 0 ? "".concat(months, " month").concat(months > 1 ? "s" : "") : "";

      if (formatedMonthString !== "" && formatedYearString !== "") {
        formatedYearString += ", ";
      }

      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, {
        enableSubfooter: true,
        defaultProduct: _MarketingCarousel.MARKETING_CARDS.CSU,
        legalTextKeys: LEGAL_TEXT_KEYS
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-paydown"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hero-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        className: "background-triangle",
        src: require("../assets/redesign2020/slp/background-triangle.svg")
      }), /*#__PURE__*/_react.default.createElement(_MarketingHero.default, {
        desktopImage: require("../assets/redesign2020/slp/desktop-hero.png"),
        tabletImage: require("../assets/redesign2020/slp/tablet-hero.png"),
        mobileImage: require("../assets/redesign2020/slp/mobile-hero.png"),
        containsChevron: false,
        logo: require("../assets/home/icon-paydown-dark.svg")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "header-subtitle"
      }, "Student Loan"), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted paydown"
      }, "PayDown"), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Help your employees pay down their student loan debt faster through direct contributions toward their student loans so ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "they can focus on their next financial goal"), "."))), /*#__PURE__*/_react.default.createElement(_MarketingProductNavbar.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-details-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "paydown-details-header"
      }, "A more engaged, ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "less stressed workforce"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "paydownDetails1",
        className: "paydown-details-body-text"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-details-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "paydown-details-header"
      }, "The ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Financial"), " Impact"), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "paydownDetails2",
        className: "paydown-details-body-text legal-text-1"
      })), /*#__PURE__*/_react.default.createElement("img", {
        alt: "The Financial Impact",
        src: require("../assets/redesign2020/slp/details-image.jpg"),
        className: "paydown-details-image"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-calculator"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: require("../assets/home/icon-paydown-dark.svg"),
        alt: "",
        className: "slp-logo",
        "aria-hidden": "true"
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "paydown-calculator-header"
      }, "See how ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "SLP Plan\xAE contributions"), " can make a lasting impact."), /*#__PURE__*/_react.default.createElement(_MarketingImpactCalculatorWrapper.default, {
        enableLoanCustomization: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-footer"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "paydown-footer-header"
      }, "A ", (0, _numeral.default)(extraPayment).format("$0,0"), "/mo SLP Plan ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "saves up to ", _formatters.default.moneyWhole(principalSavings)), " and allows employees to ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "pay off their debt ", formatedYearString, formatedMonthString, " earlier"), ".*"), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        className: "paydown-footnotes",
        contentKey: "paydownFooter"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-impact-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-impact"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "impact-header"
      }, "The ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Human"), " Impact"), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        className: "impact-body legal-text-2",
        contentKey: "paydownImpactBody"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "impact-percentage"
      }, /*#__PURE__*/_react.default.createElement(_Percentage.default, {
        index: "1"
      }), /*#__PURE__*/_react.default.createElement(_Percentage.default, {
        index: "2"
      }), /*#__PURE__*/_react.default.createElement(_Percentage.default, {
        index: "3"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-contributions-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "paydown-contributions"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "contributions-image",
        src: require("../assets/redesign2020/slp/contribution.png"),
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "contributions-body"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h3",
        contentKey: "howItWorksHeader",
        className: "contributions-header"
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "contributions-header-2"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Make contributions"), " to your employees' student loans."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "howItWorksBody",
        className: "contributions-body-text"
      }))))), /*#__PURE__*/_react.default.createElement(_QuoteSelector.default, {
        defaultQuote: _QuoteSelector.QUOTE_CARDS.SLP
      }), /*#__PURE__*/_react.default.createElement(_OnboardingCard.default, null), /*#__PURE__*/_react.default.createElement(_CustomizeBenefits.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "logo-garden-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LogoGarden.default, null))));
    }
  }]);

  return StudentLoanPaydown;
}(_react.default.Component)) || _class;

var propulateView = (0, _Propulator.default)(StudentLoanPaydown, {
  impactCalculatorStore: ["extraPayment", "stats"]
});

var _default = (0, _MobxView.default)(propulateView, {
  impactCalculatorStore: _ImpactCalculatorStore.default,
  sessionStore: _SessionStore.default
});

exports.default = _default;